(function () {
    'use strict';

    angular.module("imApp").factory("p2ExportProcsService", ['$ihttp', function ($ihttp) {
        let service = {
            listExportProcedures: function (parms, config) {
                return $ihttp.post({
                    method: 891,
                    parameters: parms || {},
                    config: config || {}
                });
            }
        };

        return service;
    }]);
})();
